/** Must match `public.is_attempt_status_transition_allowed`. */
export enum AttemptStatus {
  InProgress = 'in_progress',
  Submitted = 'submitted',
  Marked = 'marked',
  Void = 'void',
}

/** How an assignment's set reaches students, as `set_assignments.settings.delivery`. */
export enum SetDelivery {
  Paper = 'paper',
}
